export enum ToastMessageEnum {
  ADD_COLLECTION_IMAGE = '에 저장되었습니다!',
  DELETE_COLLECTION_IMAGE = '에서 삭제되었습니다!',
  ADD_IMAGE_USE = '이미지를 사용했습니다!',
  CANCEL_IMAGE_USE = '이미지 사용을 취소했습니다!',
  IMAGE_DOWNLOAD_SUCCESS = '이미지를 다운로드 했습니다!',
  CANNOT_ATTACH_IMAGE_DURING_AI_FETCHING = 'AI 추천 생성 중에는 이미지 업로드가 제한됩니다.',
  RETRY_AFTER_AI_FETCHING = '생성이 완료된 후 다시 시도해 주세요!',
  REPORT_SUCCESS = '리포트가 제출되었습니다!',
  IMAGE_COPY_SUCCESS = '이미지를 클립보드에 저장했습니다!',
  IMAGE_DELETE_SUCCESS = '이미지가 삭제되었습니다.',
  IMAGE_HARD_DELETE_SUCCESS = '이미지가 영구적으로 삭제되었습니다.',
  USER_DELETE_SUCCESS = '회원정보가 삭제되었습니다.'
}

export enum ToastTypeEnum {
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR'
}
